<template>
  <div id="appbox">
    <div class="top_heard">
      <div class="top_box" v-if="screenWidth>785">
        <div class="logo_box" @click="gohome()">
          <img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;" height="" srcset="">
        </div>
        <div class="top_gatebox">
          <div class="manage_switch" v-if="screenWidth>785">
            <el-select v-model="manage_url" @change="manageurl" size="small" class="Site_switch_type"
                       placeholder="选择入口">
              <el-option
                  v-for="item in manageoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="top_search_box" v-if="screenWidth>785">
          <div class="top_search">
            <el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"

              >
              </el-option>
            </el-select>
            <!-- <i class="el-icon-search"></i> -->
            <input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"
                   style="border: 0px;width: 200px;height: 30px;">
            <img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt=""
                 srcset="">
          </div>

        </div>
        <div class="top_right">
          <div class="top_Mobiletype" @click="goregister()">
            账号注册/绑定
          </div>
          <div class="" v-if="token">
            欢迎访问!
          </div>
          <div class="" v-if="token" style="color: darkred;margin-left: 5px;" @click="logout()">
            登出
          </div>
        </div>
      </div>
      <div class="top_tab_box">
        <van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true"
                     v-if="screenWidth<785">
          <template #left>
            <div class="vannav_title" style="color: #217495;font-size: 16px;">
              课程详情
            </div>
          </template>
          <template #title>
            <div class="vannav_title" style="width: 180px;padding: 20px;">
              <img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;" height="" srcset="">
            </div>
          </template>
          <template #right>
            <van-icon name="ellipsis" size="20"/>
          </template>
        </van-nav-bar>
        <van-popup v-model="vannavshow" :style="{ height: '50%' }" position="top">
          <van-picker
              title=""
              show-toolbar
              :columns="vannavlist"
              confirm-button-text="进入"
              @confirm="vanlinkgo"
              @cancel="vannavmenushow"
          />
        </van-popup>
        <div class="toptabnav" v-if="screenWidth>785">
          <el-menu
              :default-active="activeIndex2"
              class="el-menu-demo"
              mode="horizontal"
              router
              background-color="#1b9d57"
              text-color="#FFFFFF"
              active-text-color="#FFFFFF">
           	<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
            <!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
          </el-menu>
        </div>
      </div>
    </div>
    <div class="main_box" :style="screenWidth>785?'':'width:100%;'">
      <div class="camp_item" :style="screenWidth>785?'':'width:calc(100% - 30px);padding:15px;'">
        <div class="moduletitle" :style="screenWidth>785?'':'font-size:18px;'">
          <span class="actblock" :style="screenWidth>785?'':'height:30px;'"></span>入驻平台
        </div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 机构类型 -->
          <el-form-item label="机构类型" prop="type">
            <el-radio-group v-model="ruleForm.type" size="medium">
              <el-radio border label="1">营地</el-radio>
              <el-radio border label="2">基地</el-radio>
              <el-radio border label="3">研学机构</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 机构名称 -->
          <el-form-item label-width="97px" label="机构名称" prop="name">
            <el-col :span="13">
              <el-input placeholder="请输入机构名称" v-model="ruleForm.name"></el-input>
            </el-col>
          </el-form-item>
          <!-- 真实姓名 -->
          <el-form-item label-width="97px" label="真实姓名" prop="truename">
            <el-col :span="6">
              <el-input placeholder="请输入真实姓名" v-model="ruleForm.truename"></el-input>
            </el-col>
          </el-form-item>
          <!-- 手机号码 -->
          <el-form-item label-width="97px" label="手机号码" prop="mobile">
            <el-col :span="6">
              <el-input placeholder="请输入手机号码" v-model="ruleForm.mobile"></el-input>
            </el-col>
          </el-form-item>
          <!-- 登录账号 -->
          <el-form-item label-width="97px" label="登录账号" prop="login_name">
            <el-col :span="6">
              <el-input placeholder="请输入登录账号" v-model="ruleForm.login_name"></el-input>
            </el-col>
          </el-form-item>
          <!-- 登录密码 -->
          <el-form-item label-width="97px" label="登录密码" prop="pass">
            <el-col :span="6">
              <el-input type="password" placeholder="请输入登录密码" v-model="ruleForm.pass"></el-input>
            </el-col>
          </el-form-item>
          <!-- 确认密码 -->
          <el-form-item label-width="97px" label="确认密码" prop="repass">
            <el-col :span="6">
              <el-input type="password" placeholder="请输入确认密码" v-model="ruleForm.repass"></el-input>
            </el-col>
          </el-form-item>
          <!-- 机构类型为机构时显示 -->
          <div v-if="ruleForm.type === '3'">
            <!-- 工商营业执照号 -->
            <el-form-item label-width="140px" label="工商营业执照号" prop="business_number">
              <el-col :span="10">
                <el-input placeholder="请输入工商营业执照号" v-model="ruleForm.business_number"></el-input>
              </el-col>
            </el-form-item>
            <!-- 旅行社经营许可证 -->
            <el-form-item label-width="155px" label="旅行社经营许可证" prop="business_license">
              <el-col :span="10">
                <el-input placeholder="请输入旅行社经营许可证" v-model="ruleForm.business_license"></el-input>
              </el-col>
            </el-form-item>
            <!-- 注册资金 -->
            <el-form-item label-width="136px" label="注册资金(万元)" prop="registered_capital">
              <el-col :span="6">
                <el-input placeholder="请输入注册资金" v-model="ruleForm.registered_capital"></el-input>
              </el-col>
            </el-form-item>
            <!-- 单位开办年月日 -->
            <el-form-item label-width="130px" label="单位创建日期">
              <el-col :span="11">
                <el-form-item prop="establishment_date">
                  <el-date-picker type="date" placeholder="请选择单位创建日期" v-model="ruleForm.establishment_date"
                                  style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交数据</el-button>
            <!--            <el-button @click="resetForm('ruleForm')">重置</el-button>-->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div :class="tops?'navbar':'navbar-top'" v-if="screenWidth>785">
      <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
        <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @click="gohome()"><i
            class="el-icon-s-home"></i>
          <div style="font-size: 14px;">首页</div>
        </a>
      </el-tooltip>
      <div class="qrShow3 right2" v-if="showofficialQR">
        <img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;"/>
      </div>
      <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"
         @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>
        <div style="font-size: 14px;">公众号</div>
      </a>
      <div class="qrShow2 right2" v-if="showserviceQR">
        <img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;"/>
      </div>
      <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"
         @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>
        <div style="font-size: 14px;">客服</div>
      </a>
      <div class="qrShow right" v-if="showQR">
        <img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;"/>
      </div>
      <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"
         @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i>
        <div style="font-size: 14px;">手机端</div>
      </a>
      <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
        <a @click="gotop"><i class="el-icon-caret-top"></i>
          <br>
          <span>顶部</span></a>
      </el-tooltip>
    </div>
    <!-- footer -->
    <div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
  </div>
</template>

<script>
import {
  getPac,
  getPc,
  getbottomnav,
  subOrgRegister,
} from '@/request/api'
import COS from "cos-js-sdk-v5";

export default {
  name: "CourseDetails",
  // components: {
  //   navTab
  // },
  data() {
    return {
      stitle: '',
      ruleForm: {
        type: '1',
        name: '',
        truename: '',
        mobile: '',
        login_name: '',
        pass: '',
        repass: '',
        business_number: '',
        business_license: '',
        registered_capital: '',
        establishment_date: '',
      },
      token: '',
      bottomnav: [],
      //搜索相关
      top_search_url: '/Siteall',
      options: [
        {
          value: '/Siteall',
          label: '全站搜索'
        }, {
          value: '/Camplist',
          label: '营地搜索'
        }, {
          value: '/Baselist',
          label: '基地搜索'
        }, {
          value: '/Courselist',
          label: '课程搜索'
        }, {
          value: '/Newslist',
          label: '资讯搜索'
        },
        {
          value: '/Activitylist',
          label: '活动搜索'
        },
        {
          value: '/Linelist',
          label: '线路搜索'
        },
        {
          value: '/traveler',
          label: '机构搜索'
        }, {
          value: '/mentorlist',
          label: '指导师搜索'
        },],
      //搜索相关
      manage_url: '',
      manageoptions: [
        {
          value: 'http://qianjin.wanjiaxiao.cn/',
          label: '研学报备'
        }, {
          value: 'https://admin.henanyanxue.com/',
          label: '管理入口'
        },

      ],
      activeIndex2: '/CourseDetails',
      phoneboxshow: false,
      userInfo: {
        username: "",
        education_name: "",
        role_level: ""
      },
      logintype: true,
      banner: [],
      camptypes: [
        {text: '全部', value: 0},
        {text: '基地', value: 2},
        {text: '营地', value: 1},
      ],
      categorytypes: [],
      camptype: 0,
      camplist: [],
      quicklist: [],
      aclist: [],
      newsiconon: '',
      category_id: 0,
      period: 0,
      total: 0,
      page_index: 1,
      activeName: 0,
      pcsetdata: {},
      //侧边栏
      showQR: false,
      showserviceQR: false,
      showofficialQR: false,
      tops: false,
      heights: window.innerHeight,
      scrolltop: '',
      //屏幕宽高
      // 屏幕宽度
      screenWidth: window.innerWidth,
      top_bannerWidth: Math.round(window.innerWidth / 3.42),
      // 屏幕高度
      screenHeight: window.innerHeight,
      //手机端导航栏
      vannavshow: false,
      vannavlist: [
        {
          link: '/Home',
          text: '研学首页'
        },
        {
          link: '/Camplist',
          text: '营地列表'
        },
        {
          link: '/Newslist',
          text: '资讯资讯'
        },
        {
          link: '/Baselist',
          text: '基地列表'
        },
        {
          link: '/Courselist',
          text: '研学课程'
        },
        {
          link: '/Activitylist',
          text: '研学活动'
        },
        {
          link: '/Linelist',
          text: '研学线路'
        },
        {
          link: '/traveler',
          text: '研学机构'
        },
        {
          link: '/mentorlist',
          text: '研学指导师'
        },
        {
          link: '/expertlist',
          text: '专家团队'
        },
        {
          link: '/OrgRegister',
          text: '入驻平台'
        },
      ],
    }
  },
  beforeCreate() {
    const loading = this.$loading({
      lock: true,
      text: '页面载入……',
      // spinner: 'el-icon-loading',
      background: '#ffffff'
    });
    loading.close();
  },
  created() {
    this.getpcset()
  },
  mounted() {
    const {id} = this.$route.query;
    window.addEventListener('resize', this.handleResize, true)
    // let token = localStorage.getItem('token') || ''
    // if (!token) {
    //   this.gologin()
    //   return
    // }
    // this.token = token
    this.getbottomnav()
    console.log("到这了");
    // this.gettypes()

    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  // 销毁监听
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 调整至登录页
    gologin() {
      this.$router.push({
        path: "/Login",
        name: "/Login",
        query: {}
      });
    },
    // 提交保险数据
    submitForm(formName) {
      // let token = localStorage.getItem('token') || ''
      // if (!token) {
      //   this.gologin()
      //   return
      // }
      let data = {}
      // checktoken(data).then(res => {
      //   if (res.data.code === 201) {
      //     console.log(res)
      //     regettoken(data).then(res => {
      //       localStorage.setItem('token', res.data.data.token)
      //       localStorage.setItem('refreshToken', res.data.data.refreshToken)
      //     })
      //   }
      // })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.name === null || this.ruleForm.name.trim() === '') {
            this.$message({
              showClose: true,
              message: '机构名称不能为空',
              type: 'error'
            });
            return;
          }
          if (this.ruleForm.truename === null || this.ruleForm.truename.trim() === '') {
            this.$message({
              showClose: true,
              message: '真实姓名不能为空',
              type: 'error'
            });
            return;
          }
          if (!(/^1\d{10}$/.test(this.ruleForm.mobile))) {
            this.$message({
              showClose: true,
              message: '手机号码为空或格式错误',
              type: 'error'
            });
            return;
          }
          if (this.ruleForm.login_name === null || this.ruleForm.login_name.trim() === '') {
            this.$message({
              showClose: true,
              message: '登录账号不能为空',
              type: 'error'
            });
            return;
          }
          if (this.ruleForm.pass === null || this.ruleForm.pass.trim() === '') {
            this.$message({
              showClose: true,
              message: '登录密码不能为空',
              type: 'error'
            });
            return;
          }
          if (this.ruleForm.repass !== this.ruleForm.pass) {
            this.$message({
              showClose: true,
              message: '两次密码不一致',
              type: 'error'
            });
            return;
          }
          // 只有旅行机构时验证
          if (this.ruleForm.type === '3') {
            if (this.ruleForm.business_number === null || this.ruleForm.business_number.trim() === '') {
              this.$message({
                showClose: true,
                message: '工商营业执照号不能为空',
                type: 'error'
              });
              return;
            }
            if (this.ruleForm.business_number.length !== 18 || !(/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/.test(this.ruleForm.business_number))) {
              this.$message({
                showClose: true,
                message: '工商营业执照号格式不正确，格式为18位数字与英文字母组成',
                type: 'error'
              });
              return;
            }
            if (this.ruleForm.business_license === null || this.ruleForm.business_license.trim() === '') {
              this.$message({
                showClose: true,
                message: '旅行社经营许可证不能为空',
                type: 'error'
              });
              return;
            }
            if (this.ruleForm.registered_capital === null || this.ruleForm.registered_capital.trim() === '') {
              this.$message({
                showClose: true,
                message: '注册资金不能为空',
                type: 'error'
              });
              return;
            }
            if (this.ruleForm.establishment_date === '') {
              this.$message({
                showClose: true,
                message: '请选择单位创建日期',
                type: 'error'
              });
              return;
            }
          }
          let that = this;
          // 整理提交的数据
          let subData = {
            type: that.ruleForm.type,
            name: that.ruleForm.name,
            truename: that.ruleForm.truename,
            mobile: that.ruleForm.mobile,
            login_name: that.ruleForm.login_name,
            pass: that.ruleForm.pass,
            repass: that.ruleForm.repass,
            business_number: that.ruleForm.business_number,
            business_license: that.ruleForm.business_license,
            registered_capital: that.ruleForm.registered_capital,
            establishment_date: that.dateFormat(that.ruleForm.establishment_date),
          }
          that.$confirm('请您确认所填信息是否正确，点击确认后信息将无法修改', '确认信息', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 继续根据当前待支付订单生成二维码图片跳转到待支付投保单单页面
            subOrgRegister(subData).then(res => {
              if (res.data.code === 200) {
                that.$confirm(res.data.data, '确认信息', {
                  confirmButtonText: '我知道了',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
              }).catch(() => {});
              } else {
                that.$message({
                  message: res.data.msg,
                  type: 'warning'
                });
              }
            })
          }).catch(() => {});
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置保险数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 日期转换为正常格式
    dateFormat(time) {
      const date = new Date(time);
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0')
    },
    // 身份证号验证
    isIdCardNo(num) {
      if (isNaN(num)) {
        console.log("输入的不是数字！");
        return false;
      }
      var len = num.length, re;
      if (len === 15)
        re = new RegExp(/^(\d{6})()?(\d{2})(\d{2})(\d{2})(\d{3})$/);
      else if (len === 18)
        re = new RegExp(/^(\d{6})()?(\d{4})(\d{2})(\d{2})(\d{3})(\d)$/);
      else {
        console.log("输入的数字位数不对！");
        return false;
      }
      var a = num.match(re);
      if (a != null) {
        if (len === 15) {
          var D = new Date("19" + a[3] + "/" + a[4] + "/" + a[5]);
          var B = D.getYear() == a[3] && (D.getMonth() + 1) == a[4] && D.getDate() == a[5];
        } else {
          var D = new Date(a[3] + "/" + a[4] + "/" + a[5]);
          var B = D.getFullYear() == a[3] && (D.getMonth() + 1) == a[4] && D.getDate() == a[5];
        }
        if (!B) {
          console.log("输入的身份证号 " + a[0] + " 里出生日期不对！");
          return false;
        }
      }
      return true;
    },
    gotopsearch() {
      this.$router.push({
        path: this.top_search_url,
        name: this.top_search_url,
        query: {
          stitle: this.stitle,
        }
      });
    },
    manageurl(e) {
      console.log('Site', e)
      if (e != '/') {
        window.open(e)
      }
      //this.manage_url = '/'
      // window.location.href = e;

    },
    vanlinkgo(e) {
      console.log(e)
      this.$router.push({
        path: e.link,
        name: e.link,
        query: {}
      });
    },
    vannavmenushow() {
      this.vannavshow = false
    },
    handleResize() {
      this.top_bannerWidth = 0;
      this.screenWidth = window.innerWidth;
      this.top_bannerWidth = window.innerWidth / 3.42
      console.log('screenWidth', this.screenWidth, this.top_bannerWidth)
      this.screenHeight = window.innerHeight;
    },
    getbottomnav() {
      var data = {
        page_index: 1,
        page_size: 15
      }
      getbottomnav(data).then(res => {
        this.bottomnav = res.data.data.list
      })
    },
    gobottomnav(type, link) {
      if (type == 1) {
        this.$router.push({
          path: link
        });
      } else if (type == 2) {
        window.location.href = link;
      }
    },
    logout() {
      var that = this
      this.$confirm('是否确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$alert("已退出登录", '', {
          confirmButtonText: '确认',
          callback: action => {
            localStorage.setItem('token', '')
            localStorage.setItem('refreshToken', '')
            that.$router.go(0)
          }
        });
      }).catch(() => {

      });
    },
    showofficialQRCode() {
      this.showofficialQR = true
    },
    hideofficialQRCode() {//隐藏二维码
      this.showofficialQR = false
    },
    showserviceQRCode() {
      this.showserviceQR = true
    },
    hideserviceQRCode() {//隐藏二维码
      this.showserviceQR = false
    },
    showQRCode() {//显示二维码
      this.showQR = true
    },
    hideQRCode() {//隐藏二维码
      this.showQR = false
    },
    scrollToTop() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrolltop = scrollTop
      if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
        this.tops = true
      } else {
        this.tops = false
      }
    },
    gotop() {
      let timer = setInterval(() => {
        document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
        if (this.scrolltop === 0) {
          clearInterval(timer)
        }
      }, 15)
    },
    showphonebox() {
      this.phoneboxshow = true
    },
    closephonebox() {
      this.phoneboxshow = false
    },
    goregister(e) {
      this.$router.push({
        path: "/register",
        name: "/register",
        query: {}
      });
    },
    gomap(e) {
      this.$router.push({
        path: "/Campmap",
        name: "/Campmap",
        query: {
          latitude: e.latitude,
          longitude: e.longitude,
        }
      });
    },
    gohome(e) {
      this.$router.push({
        path: "/Home",
        name: "/Home",
        query: {}
      });
    },
    getpcset() {
      getPc().then(res => {
        this.pcsetdata = res.data.data
      })
    },
    camptypetab(val) {
      this.category_id = val
      this.getlist()
    },
    periodtab(val) {
      this.period = val
      this.getlist()
    },
    pagechange(val) {
      this.page_index = val
      this.getlist()
    },
    handleClick(e) {
      console.log(e, this.category_id)
      this._getNewslist()
    },
    onitemopen(index) {
      this.newsiconon = index
    },
    gettypes() {
      var data = {}
      getPac(data).then(res => {
        console.log(res.data)
        this.categorytypes = res.data.data.cat
        this.periodtypes = res.data.data.res
        // this.category_id=res.data.data.cat[0].id
        // this.getlist()
      }).catch(error => {
        console.error(error);
      });
    },
    /*
     * 查看详情
     * */
    gocampdetail(e) {
      this.$router.push({
        path: "/CampDetails",
        name: "CampDetails",
        query: {
          id: e
        }
      });
    },

  }
};
</script>

<style scoped>
.coursemain_richitem {
  padding-bottom: 50px;
}

.coursemain {
  padding: 5px 20px;
  font-size: 16px;
  line-height: 24px;
  text-indent: 2rem;
  text-align: left;
}

.el-tag--dark {
  border: 0px;
  margin: 0px 2px;
}

.camp_item {
  padding: 20px;
  margin-top: 20px;
  /* width: 1060px; */
  background: #ffffff;

}

.campmsg_box {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.camp_img {
  width: 337.5px;
  height: 161px;
  margin-left: 30px;
}

.camp_img img {
  width: 100%;
  height: 100%;
}

.camp_msg {
  width: 660px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}

.camp_title {
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  padding: 20px 0px;
}

.camp_address {
  color: #1b9d57;
  padding-bottom: 20px;
  font-size: 16px;
  text-align: left;
}

.camp_phone {
  padding-bottom: 20px;
  color: #66b1ff;
  text-align: left;
}

.moduletitle {
  display: flex;
  align-items: center;
  font-size: 20px;
  margin-bottom: 10px;
}

.rich_title {
  padding: 20px;
  padding-bottom: 0px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.richblock {
  width: 6px;
  height: 30px;
  margin-right: 20px;
  display: block;
  background: #1b9d57;
}

.coursemain_box {
  /* padding: 20px; */
  background: #ffffff;
  margin-top: 20px;
}

@media only screen and (max-width: 768px) {
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
    padding-right: 20px !important;
  }
}
</style>